import { initialSorting } from '@constants/tableSorting';

import { createStore } from '@store/createStore';

const useAssetTrackerStore = createStore((set) => ({
  activeAssetInfo: null,
  assetCreatedTracker: null,
  searchValue: '',
  filterAssetStatus: 'active',
  assetTableSorting: initialSorting,
  actions: {
    setActiveAssetInfo: (activeAssetInfo) => set({ activeAssetInfo }),
    setAssetCreatedTracker: (assetCreatedTracker) => set({ assetCreatedTracker }),
    setSearchValue: (searchValue) => set({ searchValue }),
    setFilterAssetStatus: (filterAssetStatus) => set({ filterAssetStatus }),
    setAssetTableSorting: (assetTableSorting) => set({ assetTableSorting }),
    setClearActiveAsset: () => set({ activeAssetInfo: null }),
  },
}));

export const useAssetTrackerActions = () => useAssetTrackerStore((state) => state.actions);

export const selectActiveAssetInfo = () => useAssetTrackerStore((state) => state.activeAssetInfo);
export const selectAssetCreatedTracker = () => useAssetTrackerStore((state) => state.assetCreatedTracker);
export const selectSearchValue = () => useAssetTrackerStore((state) => state.searchValue);
export const selectFilterAssetStatus = () => useAssetTrackerStore((state) => state.filterAssetStatus);
export const selectAssetTableSorting = () => useAssetTrackerStore((state) => state.assetTableSorting);
